import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

class ListCarousel {

    constructor(el) {
        this.el = el;
        this.widthLimit = el.dataset.crossfadeBelow !== '' ? parseInt(el.dataset.crossfadeBelow) : 0;
        this.running = false;
        this.items = [...el.querySelectorAll('li')];
        this.itemsLength = this.items.length;
        this.activeIndex = -1;
        this.timeout = null;
        this.paused = false;
        this.resizeRequested = false;
        this.resizeTimeout = null;

        if(this.widthLimit > 0) {

            // add resize observer
            this.ro = new ResizeObserver(() => {
                if(!this.resizeRequested) {
                    this.resizeRequested = true;
                    this.resizeTimeout = setTimeout(() => {
                        this.resize();
                        this.resizeRequested = false;
                        this.resizeTimeout = null;
                    }, 100);
                }
            });
            this.ro.observe(this.el); // Watch dimension changes wrapping element

        }

        // pause carousel on mouseover
        this.el.onmouseover = () => {
            this.paused = true;
            clearTimeout(this.timeout);
        }
        this.el.onmouseout = () => {
            this.paused = false;
            if(this.running) {
                this.timeout = setTimeout(() => {
                    this.next();
                }, 4000);
            }
        }
    }

    resize() {
        let active = this.el.offsetWidth < this.widthLimit;
        for(let x = 0; x < this.itemsLength; x++) {
            this.items[x].classList.toggle('fade', active);
            this.items[x].removeAttribute('hidden');
        }
        // start / stop
        if(active) {
            if(!this.running) this.next();
        } else {
            // turn off and show all list items
            if(this.running) this.disable();
        }
    }

    next() {
        if(!this.paused) {
            this.el.classList.add('carousel-active');
            this.running = true;
            this.activeIndex++;
            if(this.activeIndex >= this.itemsLength) this.activeIndex = 0;
            for(let x = 0; x < this.itemsLength; x++) this.items[x].classList.toggle('item-active', x == this.activeIndex);
            this.timeout = setTimeout(() => {
                this.next();
            }, 4000);
        }
    }

    disable() {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.running = false;
        this.el.classList.remove('carousel-active');
        for(let x = 0; x < this.itemsLength; x++) this.items[x].classList.remove('item-active');
    }
}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ListCarousel(node);
        }
    });
}

